import { useQuery } from '@tanstack/react-query';
import { getETHBalance } from '../chains/evm/api';
import { isEVMChain } from './chains';
export function useEVMBalance({ chain, address, blockTag = 'pending', refetchInterval = 4000, }) {
    const query = useQuery({
        queryKey: ['evm-balance', chain, address, blockTag],
        queryFn: async () => {
            if (!address)
                return null;
            const value = await getETHBalance(chain, address);
            return { value, decimals: 18 };
        },
        enabled: Boolean(address && isEVMChain(chain)),
        refetchInterval,
    });
    return {
        data: query.data ?? undefined,
        error: query.error,
        isPending: query.isPending,
        isFetching: query.isFetching,
        isSuccess: query.isSuccess,
        status: query.status,
        refetch: query.refetch,
    };
}
